import { Routes } from '@angular/router';

export const routes: Routes = [
  // {
  //   path: '',
  //   pathMatch: 'full',
  //   title: 'DriveRight Lagos | Driving Lessons & Licence Guidance',
  //   loadComponent: () => import('./landing-page/landing-page').then((m) => m.LandingPage),
  // },
  // {
  //   path: 'terms-and-conditions',
  //   title: 'Terms & Conditions | DriveRight Lagos',
  //   loadComponent: () => import('./landing-page/landing-terms').then((m) => m.LandingTerms),
  // },

  // ── Shared auth ─────────────────────────────────────────────
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./shared/components/forgot-password/forgot-password').then((m) => m.ForgotPassword),
  },
  {
    // Landing page for the reset link emailed by SendPasswordResetCode; the
    // link carries userId, resetCode and c as query params.
    path: 'reset-password',
    loadComponent: () =>
      import('./shared/components/reset-password/reset-password').then((m) => m.ResetPassword),
  },

  {
    // Landing page for the payment gateway's callback. Renders inside the
    // checkout iframe, or standalone when the gateway redirects the whole page.
    path: 'payment-confirmation',
    loadComponent: () =>
      import('./shared/components/payment-confirmation/payment-confirmation').then(
        (m) => m.PaymentConfirmation,
      ),
  },

  // ── Learner module ───────────────────────────────────────────
  {
    path: 'learner',
    loadChildren: () => import('./learner/learner.routes').then((m) => m.learnerRoutes),
  },

  // ── Driving School module ────────────────────────────────────
  {
    path: 'driving-school',
    loadChildren: () =>
      import('./driving-school/driving-school.routes').then((m) => m.drivingSchoolRoutes),
  },
  {
    path: 'instructor',
    loadChildren: () => import('./instructor/instructor.routes').then((m) => m.instructorRoutes),
  },

  // ── VIS module ────────────────────────────────────
  {
    path: 'vis',
    loadChildren: () => import('./vis/vis.routes').then((m) => m.visRoutes),
  },

  // ── VIS Instructor ────────────────────────────────────
  {
    path: 'vis-instructor',
    loadChildren: () =>
      import('./vis-instructor/vis-instructor.routes').then((m) => m.visInstructorRoutes),
  },
  {
    path: 'vis-examiner',
    loadChildren: () =>
      import('./vis-examiner/vis-examiner.routes').then((m) => m.visExaminerRoutes),
  },

  // ── Driving Institute ────────────────────────────────────
  {
    path: 'driving-institute',
    loadChildren: () =>
      import('./driving-institute/driving-institute.routes').then((m) => m.drivingInstituteRoutes),
  },

  // ── SuperAdmin ─────────────────────────────────────────────────
  {
    path: 'admin',
    loadChildren: () => import('./super-admin/super-admin.routes').then((m) => m.superAdminRoutes),
  },
  {
  path: 'module-not-assigned',
  loadComponent: () =>
    import('./shared/components/dynamic-module/module-not-assigned.component')
      .then(m => m.ModuleNotAssignedComponent),
},
{
    path: '',
    pathMatch: 'full',
    redirectTo:'learner'
  },
];
